import React from 'react';

class DateRangePicker extends React.Component {
  render() {
    const month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Array.range(3, 7) => [3, 4, 5, 6, 7]
    Array.range = (start, end) => Array.from({ length: (end - start + 1) }, (_, k) => k + start);
    var yearRange = Array.range(2005, 2019)
    var startYearOptions = yearRange.map((x) => {
      if (x === this.props.startYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    var endYearOptions = yearRange.map((x) => {
      if (x === this.props.endYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    var monthRange = Array.range(1, 12);
    var startMonthOptions = monthRange.map((x) => {
      if (x === this.props.startMonth) {
        return (<option selected value={x}>{month_names[x - 1]}</option>)
      } else {
        return (<option value={x}>{month_names[x - 1]}</option>)
      }
    });
    var endMonthOptions = monthRange.map((x) => {
      if (x === this.props.endMonth) {
        return (<option selected value={x}>{month_names[x - 1]}</option>)
      } else {
        return (<option value={x}>{month_names[x - 1]}</option>)
      }
    });

    return (
      <form style={{ 'margin-left': '10%', 'margin-right': '10%', 'padding-bottom': '20px' }}>
        <div class="form-row">
          <div class="form-group col-md-3">
            <label>Start Year</label>
            <select class="form-control" name="startYear" onChange={this.props.onChange}>
              {startYearOptions}
            </select>
          </div>
          <div class="form-group col-md-3">
            <label>Start Month</label>
            <select class="form-control" name="startMonth" onChange={this.props.onChange}>
              {startMonthOptions}
            </select>
          </div>
          <div class="form-group col-md-3">
            <label>End Year</label>
            <select class="form-control" name="endYear" onChange={this.props.onChange}>
              {endYearOptions}
            </select>
          </div>
          <div class="form-group col-md-3">
            <label>End Month</label>
            <select class="form-control" name="endMonth" onChange={this.props.onChange}>
              {endMonthOptions}
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button type="button" class="btn btn-outline-secondary" onClick={this.props.onClick}>Submit</button>
        </div>
      </form>
    );
  }
}

export default DateRangePicker;